import { Facebook, Instagram } from "lucide-react";
import { FACEBOOK_URL, INSTAGRAM_URL } from "@/lib/constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#DAD0BA] mt-24 bg-[#E9E0CC]/40">
    <div className="max-w-3xl mx-auto px-6 py-12 flex flex-col items-center text-center gap-6">
      <img src="/inalign-logo.png" alt="InAlign Wellness logo" className="h-24 w-auto object-contain" />
      <p className="text-sm text-[#5C5848] max-w-md">
        Coaching to build discipline and consistency around nutrition and fitness — so you can be fit for life.
      </p>
      <div>
        <p className="uppercase tracking-[0.2em] text-xs mb-3 text-[#33311F]">Follow along</p>
        <div className="flex items-center justify-center gap-3">
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook"
            aria-label="InAlign Wellness on Facebook"
            className="flex items-center gap-2 rounded-full bg-[#556B2F] text-white px-4 py-2 text-sm hover:bg-[#44531F] transition-colors"
          >
            <Facebook className="w-4 h-4" /> Facebook
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            aria-label="InAlign Wellness on Instagram"
            className="flex items-center gap-2 rounded-full bg-[#C0714A] text-white px-4 py-2 text-sm hover:bg-[#A85B3D] transition-colors"
          >
            <Instagram className="w-4 h-4" /> Instagram
          </a>
        </div>
      </div>
      <div className="text-sm text-[#5C5848]">
        <p className="uppercase tracking-[0.2em] text-xs mb-3 text-[#33311F]">Contact</p>
        <p>inalignwellness@gmail.com</p>
        <p>(919) 480-2137</p>
        <p>Virtual · Serving clients nationwide</p>
      </div>
    </div>
    <div className="text-center text-xs text-[#5C5848] pb-8">© {new Date().getFullYear()} InAlign Wellness. All rights reserved.</div>
  </footer>
);
